import { render } from "./PR14-090622.vue?vue&type=template&id=0718147c"
import script from "./PR14-090622.vue?vue&type=script&lang=js"
export * from "./PR14-090622.vue?vue&type=script&lang=js"

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__